import { render } from "./cookie-policy.vue?vue&type=template&id=66f4c6db&scoped=true"
import script from "./cookie-policy.vue?vue&type=script&lang=js"
export * from "./cookie-policy.vue?vue&type=script&lang=js"

import "./cookie-policy.vue?vue&type=style&index=0&id=66f4c6db&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f4c6db"]])

export default __exports__